import request from '@/plugins/axios';
import {CacheService} from "../service/common";
import {OrderState, OrderStateLabel,RefundState} from "../service/enum";
import Vue from "vue";


export default {

  /*
* 元转分
* @param money 要处理金额
* */

  toFen(money) {
    let moneyYf = money.toString().split(".");
    if (moneyYf.length == 2) {
      if (moneyYf[1].length > 2) {
        moneyYf[1] = moneyYf[1].substring(0, 2);
      }
      return parseInt(moneyYf[0] + moneyYf[1].padEnd(2, "0"));
    }
    return parseInt(moneyYf[0] + "00");
  },

  /*
*  分转元
* @param money 要处理金额
* */

  toYuan(money) {
    let moneyStr = money.toString();
    if (moneyStr.length > 2) {
      return moneyStr.slice(0, moneyStr.length - 2) + '.' + moneyStr.slice(moneyStr.length - 2);
    }
    const tmp = moneyStr.padStart(3, "0");
    return tmp.slice(0, tmp.length - 2) + '.' + tmp.slice(tmp.length - 2);
  },
  //审核线下订单
  modifyOffLinePayExamine(postData){
    return request.post(`/Opencloud/OffLinePayExamine/ModifyOffLinePayExamine`,postData);
  },
  

  //线下订单审核列表
  getOfflineOrderList(params) {
    // orderNo,auditStatus,pageIndex,pageSize
    const url = `/Opencloud/OffLinePayExamine/OffLinePayExaminePageList`
    return request.get(url,{params});
    // return request.get(`/Opencloud/OffLinePayExamine/OffLinePayExaminePageList?orderNo=${orderNo}&auditStatus=${auditStatus}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  },
  //线下订单审核列表
  getOfflineOrderInfo(id) {
    // orderNo,auditStatus,pageIndex,pageSize
    const url = `/Opencloud/OffLinePayExamine/OffLinePayExamineInfo?id=${id}`
    return request.get(url);
    // return request.get(`/Opencloud/OffLinePayExamine/OffLinePayExaminePageList?orderNo=${orderNo}&auditStatus=${auditStatus}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  },
  //获取订单信息
  getOrderInfo(orderId) {
    return request.get(`/Opencloud/Pay/OrderInfo?orderNo=${orderId}`);
  },

  //获取订单列表
  getOrderList(params) {
    // pageIndex pageSize appName packageKey closeState orderNo orderState payState beginTime endTime type payBeginTime  payEndTime
    return request.get(`Opencloud/Pay/OrderList_Application`,{ params });
  },
  //获取应用列表
  getApplicationPageList() {
    const {compId} = CacheService.get("comp");
    return request.get(`/Opencloud/Application/ApplicationPageList?pageSize=99999&pageIndex=1&appSource=2`);
  },
  // 下载订单
  async downloadList(params) {
    const {compId: saleCompId} = CacheService.get("comp");
      await request.get(`/Opencloud/Pay/OrderListExport_Application`,{ params:{ saleCompId, ...params}});
  },
  getOrderStateLabel(orderState, payState) {
    switch (String(orderState)) {
      case Math.abs(OrderState.cancel).toString():
        return OrderStateLabel[OrderState.cancel];
      case OrderState.refund:
        return OrderStateLabel[OrderState.refund];
      case OrderState.refunding:
        return OrderStateLabel[OrderState.refunding];
      case OrderState.success:
        return payState == OrderState.wait ? OrderStateLabel[OrderState.wait] : OrderStateLabel[OrderState.success];
      case OrderState.rebate:
        return OrderStateLabel[OrderState.rebate];
    }
  },
  //获取退款单
  getRefundList(params) {
    // pageIndex pageSize noKey appName packageKey refundState beginTime endTime type refundBeginTime refundEndTime
    return request.get(`/Opencloud/Refund/RefundList`,{params});
  },
  //获取退款单信息
  getRefundInfo(orderId) {
    return request.get(`/Pay/Refund/RefundInfo?orderNo=${orderId}`);
  },
  //审核退款单
  approveRefund(postData) {
    return request.post(`/Opencloud/Refund/ApproveRefund`, postData);
  },
  // 下载退款单
  async downloadRefundList(params) {
    const {compId: saleCompId} = CacheService.get("comp");
    await request.get(`/Opencloud/Refund/RefundListExport`,{ params:{ saleCompId, ...params}});
  },
  getRefundLogColor(state) {
    let logColor = "";
    switch (state.toString()) {
      case RefundState.pass:
        logColor = "blue";
        break;
      case RefundState.fail:
        logColor = "red";
        break;
      default:
        break;
    }
    return logColor;
  },
}
